import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from "@/components/ui/carousel";
import { Quote } from "lucide-react";
export default function StudentSuccessStories() {
  const testimonials = [{
    author: "Juan P.",
    quote: "\"Gracias a Zafiro Investments, ahora puedo invertir con confianza en la bolsa de EE. UU.\"",
    position: "Estudiante",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1401256/img/student_juan_portrait.png"
  }, {
    author: "María L.",
    quote: "La mejor formación en inversión que he recibido, altamente recomendable.",
    position: "Exestudiante",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1401256/img/student_maria_portrait.png"
  }];
  return <section className="py-16 md:py-24 bg-background">
      <div className="container max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-12 animate-fade-in-up">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-semibold text-foreground mb-4">
            Historias de Éxito de Nuestros Estudiantes
          </h2>
          <p className="text-base md:text-lg text-muted-foreground max-w-2xl mx-auto">
            Descubre cómo Zafiro Investments ha transformado la forma en que nuestros estudiantes entienden e invierten en el mercado estadounidense.
          </p>
        </div>

        <Carousel opts={{
        align: "start",
        loop: true
      }} className="w-full max-w-5xl mx-auto">
          <CarouselContent>
            {testimonials.map((testimonial, i) => <CarouselItem key={i} data-index={i} className="md:basis-1/2 lg:basis-1/2">
                <div className="p-2 h-full">
                  <Card className="h-full shadow-soft hover:shadow-medium transition-shadow duration-[var(--duration-medium)] border border-[var(--color-border)]">
                    <CardHeader className="pb-4">
                      <div className="flex items-start gap-3">
                        <div className="flex-shrink-0 w-12 h-12 rounded-full overflow-hidden">
                          <img src={testimonial.image} alt={testimonial.author} className="w-full h-full object-cover" />
                        </div>
                        <div className="flex-1">
                          <CardTitle className="text-lg font-semibold text-foreground">
                            {testimonial.author}
                          </CardTitle>
                          <p className="text-sm text-muted-foreground mt-1">
                            {testimonial.position}
                          </p>
                        </div>
                      </div>
                    </CardHeader>
                    <CardContent>
                      <blockquote className="text-base text-foreground leading-relaxed italic">
                        "{testimonial.quote}"
                      </blockquote>
                    </CardContent>
                  </Card>
                </div>
              </CarouselItem>)}
          </CarouselContent>
          <CarouselPrevious className="hidden md:flex -left-12 bg-surface border-[var(--color-border)] hover:bg-primary hover:text-primary-foreground transition-all duration-[var(--duration-medium)]" />
          <CarouselNext className="hidden md:flex -right-12 bg-surface border-[var(--color-border)] hover:bg-primary hover:text-primary-foreground transition-all duration-[var(--duration-medium)]" />
        </Carousel>

        <div className="mt-8 flex justify-center gap-2 md:hidden">
          <div className="text-sm text-muted-foreground">
            Desliza para ver más testimonios
          </div>
        </div>
      </div>
    </section>;
}